import React, { useState, useRef, useEffect } from "react";
import "./Popover.css";

interface PopoverProps {
  children: React.ReactNode;
  content: React.ReactNode;
  position?: "top" | "right" | "bottom" | "left";
  className?: string;
  contentClassName?: string;
  showArrow?: boolean;
  disabled?: boolean;
}

const Popover: React.FC<PopoverProps> = ({
  children,
  content,
  position = "top",
  className = "",
  contentClassName = "",
  showArrow = true,
  disabled = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    if (!disabled) {
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (!disabled) {
      setIsVisible(false);
    }
  };

  return (
    <div
      className={`popover-container ${className}`}
      ref={containerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {isVisible && (
        <div
          className={`popover-content popover-${position} ${contentClassName} ${
            showArrow ? "with-arrow" : ""
          }`}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Popover;
